import React from 'react';
import styled from 'styled-components';

const MetricTrustBadge = ({ tier = 'derived' }) => {
    const label = {
        verified: 'Verified',
        derived: 'Derived',
        estimated: 'Estimated',
    }[tier] || tier;

    return <Badge $tier={tier}>{label}</Badge>;
};

export default MetricTrustBadge;

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 0.1875rem 0.5625rem;
    font-size: 0.6875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    background: ${({ theme, $tier }) =>
        $tier === 'verified' ? (theme.colors.successBg || '#ecfdf5') :
        $tier === 'estimated' ? (theme.colors.warningBg || '#fffbeb') :
        (theme.colors.infoBg || '#eff6ff')};
    color: ${({ theme, $tier }) =>
        $tier === 'verified' ? (theme.colors.success || '#28a745') :
        $tier === 'estimated' ? (theme.colors.warning || '#ffc107') :
        (theme.colors.info || '#17a2b8')};
`;

